"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useConnectivityStatus;

var _WebChatReduxContext = require("../WebChatReduxContext");

function useConnectivityStatus() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var connectivityStatus = _ref.connectivityStatus;
    return connectivityStatus;
  })];
}